<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Report-Import-Errors",
  path: "errors",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
